import React from 'react';

export function Tab({children}){
    return (<></>);
}